import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ThemePalette } from '@angular/material/core';
import { ProgressBarMode } from '@angular/material/progress-bar';

@Component({
  standalone: false,
  selector: 'migo-apps-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
})
export class HelpComponent implements OnInit {
  dialogType: 'date' | 'info' | 'cvv' | undefined;
  color: ThemePalette = 'primary';
  mode: ProgressBarMode = 'determinate';
  value = 100;
  timer = 15;
  @ViewChild('ok') ok?: ElementRef<HTMLElement>;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { helpType: 'date' | 'info' | 'cvv' }
  ) {}

  ngOnInit(): void {
    this.dialogType = this.data.helpType;
    if (this.dialogType === 'info') {
      this.decrementTime();
    }
  }

  decrementTime() {
    if (this.timer > 0) {
      setTimeout(() => {
        this.timer--;
        this.value = (this.timer * 100) / 15;
        this.decrementTime();
      }, 1000);
    } else {
      const el = this.ok?.nativeElement;
      if (el) {
        el.click();
      }
    }
  }
}
